// extracted by mini-css-extract-plugin
export var active = "HeroCarousel-module--active--ZJ-dA";
export var slide = "HeroCarousel-module--slide--P+2kN";
export var wrapper = "HeroCarousel-module--wrapper--1+cm3";